import { gql } from '@apollo/client';

export const GET_SETTLEMENT_FEE_ITEM_PAGE = gql`
  query GetSettlementFeeItemPage($filters: SettlementFeeItemFilterInput, $pageRequest: PageRequestTypeInput) {
    getSettlementFeeItemPage(filters: $filters, pageRequest: $pageRequest) {
      content {
        id
        businessScenarioCode
        name
        nameEn
        code
        isTaxInclude
        minAmount
        maxAmount
        amountSign
        allowAdjustment
        pricingItemCodes
        mainItemId
        isAdjustItem
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export const GET_SETTLEMENT_FEE_ITEM_CHILDREN = gql`
  query GetSettlementFeeItemChildren($mainItemId: Long!) {
    getSettlementFeeItemChildren(mainItemId: $mainItemId) {
      id
      businessScenarioCode
      name
      nameEn
      code
      amountSign
      allowAdjustment
      pricingItemCodes
      mainItemId
      isAdjustItem
    }
  }
`;

export const GET_SETTLEMENT_FEE_ITEM_MAX_CODE = gql`
  query GetSettlementFeeItemMaxCode($businessScenarioCode: Long!) {
    getSettlementFeeItemMaxCode(businessScenarioCode: $businessScenarioCode)
  }
`;

export const CREATE_SETTLEMENT_FEE_ITEM = gql`
  mutation CreateSettlementFeeItem($input: CreateSettlementFeeItemInput!) {
    createSettlementFeeItem(input: $input)
  }
`;


export const UPDATE_SETTLEMENT_FEE_ITEM = gql`
  mutation UpdateSettlementFeeItem($input: UpdateSettlementFeeItemInput!) {
    updateSettlementFeeItem(input: $input)
  }
`;

export const DELETE_SETTLEMENT_FEE_ITEM = gql`
  mutation DeleteSettlementFeeItem($id: ID!) {
    deleteSettlementFeeItem(id: $id)
  }
`;
